import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";

const DialogModal = (props) => {
    return <>
        <Dialog {...props}>
            <DialogTitle>
                {props.title}
            </DialogTitle>
            <DialogContent>
                {props.children}
            </DialogContent>
            <DialogActions>
                {props.actions.map((action, index) => <Button
                        key={`modal-action_${index}`}
                        variant={action.variant}
                        onClick={action.onClick}
                        color={action.color ? action.color : 'primary'}
                        type={action.type ? action.type : 'button'}>
                        { action.label }
                    </Button>)}
            </DialogActions>
        </Dialog>
    </>
}

export default DialogModal;